"use client";

import styled from "styled-components";

import Image from "../image";
import Button from "../button";
import { Swiper } from "swiper/react";

interface BoxAlertProductProps {
  $isLowStock?: boolean;
}

export const CardService = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  padding: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: 0.4s;
  background: var(--backgroundColorCard);

  &:hover {
    box-shadow: var(--shadowHoverCard);
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  padding-top: 15px;
  position: relative;
`;

export const ButtonCloseBox = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  padding: 5px 8px;
  font-size: 13px;
`;

export const FirstBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const BoxImage = styled.div`
  width: 96px;
  height: 96px;
  margin: auto;
  position: relative;
  margin-bottom: 10px;
`;

export const ImageEmployee = styled(Image)`
  width: 100%;
  height: 100%;
  border-radius: 100px;
  object-fit: cover;
`;

export const LastBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  flex-wrap: nowrap;
  width: 100%;
`;

export const BoxIcon = styled.div`
  background: var(--primarySystem);
  border-radius: 5px;
  padding: 5px;
  svg {
    width: 18px;
    height: 18px;
    path {
      stroke: var(--primarySystem100);
    }
    circle {
      stroke: var(--primarySystem100);
    }
  }
`;

export const TitleCard = styled.h3`
  font-family: "Inter Medium";
  font-size: 17px;
  color: var(--colorTitle);
`;

export const TitleDescription = styled.h4`
  font-family: "Inter Medium";
  font-size: 15px;
  color: var(--textLight);
`;

export const BodyCard = styled.div`
  width: 100%;
  text-align: left;
`;

export const FooterCard = styled.div`
  border-top: 1px solid var(--border);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
  padding-top: 15px;

  button {
    width: 100%;
  }

  @media (min-width: 768px) {
    flex-direction: row;

    button {
      width: fit-content;
    }
  }
`;

export const TextDescription = styled.p`
  font-family: "Inter Regular";
  color: var(--textLight);
  font-size: 15px;
`;
/* 
export const BoxAlertProduct = styled.div<BoxAlertProductProps>`
  font-size: 13px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 50px;
  background-color: ${({ $isLowStock }) => ($isLowStock ? '#ffe5e5' : `var(--softMint)`)};
  color: ${({ $isLowStock }) => ($isLowStock ? '#ff4d4f' : `var(--greenAndWhite)`)};
  position: absolute;
  right: -5px;
  top: -10px;
`;
 */

export const BoxAlertProduct = styled.div<BoxAlertProductProps>`
  font-size: 13px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 50px;
  background-color: ${({ $isLowStock }) =>
    $isLowStock ? "#ffe5e5" : "var(--primarySystem)"};
  color: ${({ $isLowStock }) =>
    $isLowStock ? "#ff4d4f" : "var(--primarySystem100)"};
  position: absolute;
  right: -5px;
  top: -10px;
`;

export const ScoreStar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "Inter Regular";
  font-size: 15px;
  color: var(--textLight);
  gap: 3px;
  wdith: 100%;

  svg {
    width: 15px;
    height: 15px;
    stroke: var(--infoSystem);
    fill: var(--infoSystem);
    margin-top: -2px;
  }
`;

export const BoxButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const ListItemEMployees = styled.ul`
  padding: 0;
  margin: 0;
`;

export const ItemEmployee = styled.li`
  display: flex;
  align-items: center;
  font-family: "Inter Regular";
  font-size: 14px;
  color: var(--textLight);
  gap: 5px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    width: 15px;
    height: 15px;
  }
`;

export const Carousel = styled(Swiper)`
  width: 100%;
  margin-bottom: 15px;
`;

export const TitlePaymentMethod = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--textColorPrimary);
`;

export const PaymentMethodList = styled.ul`
  padding: 8px 12px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin-top: 10px;
`;

export const PaymentMethodItem = styled.li`
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
`;
